import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FailedMethods() {
  const methods = ['El método de dejarlo llorar genera picos de cortisol que fragmentan el sueño.', 'Las rutinas rígidas no consideran las regresiones naturales del desarrollo.', 'El colecho forzado a veces solo suma incomodidad para ambos.', 'Los consejos de internet ignoran que cada bebé tiene una ventana de sueño única.', 'Esperar a que esté "muy cansado" solo logra que esté sobreestimulado y luche contra el sueño.'];
  return <section className="bg-lavender py-24 px-6 md:px-12" data-id="element-3">
      <div className="max-w-4xl mx-auto" data-id="element-4">
        <FadeIn data-id="element-5">
          <h2 className="text-4xl md:text-5xl text-center mb-16" data-id="element-6">
            Lo que ya probaste <br data-id="element-7" />
            <span className="italic text-periwinkle" data-id="element-8">
              (y por qué no funcionó)
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-9">
          {methods.map((method, index) => <FadeIn key={index} delay={0.1 * index} direction="left" data-id="element-10">
              <div className="flex items-start space-x-4 bg-white/60 p-6 rounded-2xl" data-id="element-11">
                <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-12" />
                <p className="text-lg text-brown/90" data-id="element-13">{method}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}